import './bootstrap';
import {createApp} from 'vue/dist/vue.esm-bundler.js';
// import {createApp} from 'vue';
import Notifications from '@kyvg/vue3-notification'
import store from "./src/store";

// import ConfirmationService from 'primevue/confirmationservice';
import Panel from './src/components/Airs/country-panel.vue'
import Noty from './src/components/Noty.vue'
import Menus from './src/components/Menus.vue'
import Footer from './src/components/Footer.vue'
import Scroll from './src/components/scroll.vue'
import Search from './src/pages/Search/index.vue'
import Home from './src/pages/Home/index.vue'
import Catalog from './src/pages/Catalog/index.vue'
import Card from './src/pages/Card/index.vue'
import Favourites from './src/pages/Personal/favourites.vue'
import Basket from './src/pages/Personal/Basket.vue'
import Make from './src/pages/Personal/Make.vue'
import Thank from './src/pages/Personal/Thank.vue'
import Contact from './src/pages/Contact/index.vue'
import Public from './src/pages/PublicOffer/index.vue'
import Personal from './src/pages/Personal/index.vue'
import Stores from './src/pages/Stores/index.vue'
import About from './src/pages/About/index.vue'
import AboutWorld from './src/pages/AboutWorld/index.vue'
import Secret from './src/pages/Secret/index.vue'
import Subscribe from './src/pages/Subscribe/index.vue'

import App from "./src/App.vue";
import { initSentry } from './src/services/sentry/index.js';

const app = createApp({});
initSentry(app);

app.component('component-menus',Menus)
app.component('component-menus',Menus)
app.component('component-footer',Footer)
app.component('component-scroll',Scroll)
app.component('component-search',Search)
app.component('component-main',Home)
app.component('component-catalog',Catalog)
app.component('component-card',Card)
app.component('component-favourites',Favourites)
app.component('component-basket',Basket)
app.component('component-make',Make)
app.component('component-thank',Thank)
app.component('component-contacts',Contact)
app.component('component-public',Public)
app.component('component-personal',Personal)
app.component('component-noty',Noty)
app.component('component-stores',Stores)
app.component('component-about',About)
app.component('component-about-world',AboutWorld)
app.component('component-secret',Secret)
app.component('component-subscribe',Subscribe)
app.component('component-panel',Panel)

app.use(store);

app.use(Notifications);

// app.use(ConfirmationService);
const trans = (key,replace = null) => {
    if(replace){
        let str;
        str = store.state.settings.lang_file[key]
        return  str.replace(':key',replace)
    }

    return store.state.settings.lang_file[key] ?? key

}
app.config.globalProperties.trans = trans

const generateKeys = (str = null) => {
    let key;
    key = `${store.state.settings.site_id}-${store.state.settings.gender}-${store.state.settings.lang}-${store.state.settings.currency}-`
    if(str){
        key +=str
    }
    return key;
}
app.config.globalProperties.generateKeys = generateKeys


const setParam = (obj = null) => {
    return   Object.assign({}, {
        site_id: store.state.settings.site_id,
        currency: store.state.settings.currency,
        gender: store.state.settings.gender,
        lang: store.state.settings.lang,
    }, obj)
}

app.config.globalProperties.setParam = setParam

/**
 * Промо из localStorage: JSON { …, code, promo_token } или legacy (строка кода + ключ promo_token).
 * При чтении legacy (JSON без promo_token + отдельный ключ) перезаписывает storage в каноническом виде.
 */
const getStoredPromo = () => {
    const rawPromo = localStorage.getItem('promo')
    const tokenLegacy = localStorage.getItem('promo_token')
    if (!rawPromo && !tokenLegacy) {
        return null
    }
    try {
        const promo = JSON.parse(rawPromo)
        if (promo && typeof promo === 'object' && typeof promo.code === 'string' && promo.code.length >= 2) {
            const hadTokenInObject =
                typeof promo.promo_token === 'string' && promo.promo_token.length >= 1
            const promoToken = hadTokenInObject
                ? promo.promo_token
                : (tokenLegacy && tokenLegacy.length >= 1 ? tokenLegacy : '')
            if (promoToken.length >= 1) {
                const merged = { ...promo, promo_token: promoToken }
                if (!hadTokenInObject) {
                    localStorage.setItem('promo', JSON.stringify(merged))
                    localStorage.setItem('promo_token', promoToken)
                }
                return merged
            }
        }
    } catch (e) {
        if (
            rawPromo &&
            tokenLegacy &&
            rawPromo.length >= 2 &&
            !rawPromo.trimStart().startsWith('{')
        ) {
            const merged = { id: null, code: rawPromo, promo_token: tokenLegacy }
            localStorage.setItem('promo', JSON.stringify(merged))
            localStorage.setItem('promo_token', tokenLegacy)
            return merged
        }
    }
    localStorage.removeItem('promo')
    localStorage.removeItem('promo_token')
    return null
}

app.config.globalProperties.getStoredPromo = getStoredPromo

const VIP_DISCOUNT_ENABLED_KEY = 'vip_discount_enabled'

const getVipDiscountEnabled = () => {
    const stored = localStorage.getItem(VIP_DISCOUNT_ENABLED_KEY)
    if (stored === null) {
        return true
    }
    return stored !== '0' && stored !== 'false'
}

const setVipDiscountEnabled = (enabled) => {
    localStorage.setItem(VIP_DISCOUNT_ENABLED_KEY, enabled ? '1' : '0')
}

const appendVipDiscountParam = (payload) => {
    payload.use_vip_discount = getVipDiscountEnabled()
    return payload
}

app.config.globalProperties.getVipDiscountEnabled = getVipDiscountEnabled
app.config.globalProperties.setVipDiscountEnabled = setVipDiscountEnabled
app.config.globalProperties.appendVipDiscountParam = appendVipDiscountParam

const updateStorage = ( value,key = 'settings') => {
    localStorage.setItem(key, JSON.stringify(value));
}

app.config.globalProperties.updateStorage = updateStorage

app.mount('#app');



$(document).on('click','.btnV1-js',function (){
    let products = $(this).closest('.product-parent ').find('.product-row ')
    let items_show = products.attr('data-items_show') - 0 + 8
    products.attr('data-items_show',items_show)
    $.each(products.find('.product'),function (item,value){
        if(items_show > item){
            $(value).show()
        }
    })
    if(items_show >= $(this).attr('data-count')-0 ){
        $(this).parent().remove()
    }
})

$(document).on('click','.pvz-id',function (e){
    e.preventDefault();
    store.state.settings.delivery_city.pvz = $(this).attr('data-pvz')
    $('.air-close').trigger('click')

})
